import TipsIcon from "@/assets/icons/image-tips.png";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import useGetDashboardTips from "@/hooks/dashboard/useGetDashboardTips";
import { useTranslation } from "react-i18next";
import TipsContent from "./TipsContent";

const DashboardTips = () => {
    const dashboardTips = useGetDashboardTips();
    const { t } = useTranslation();

    return (
        <Card
            className="h-full min-w-35 flex-1 xl:min-w-60"
            size="sm"
            variant="dashboard"
        >
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <img alt="Tips du jour" src={TipsIcon} />
                    {t("dashboard.widgets.tips")}
                </CardTitle>
            </CardHeader>
            <CardContent className="text-sm" variant="dashboard">
                <TipsContent content={dashboardTips} />
            </CardContent>
        </Card>
    );
};

export default DashboardTips;
